import { useState, useEffect } from 'react';
import { withAgentPage, withLayout } from 'hocs';
import compose from 'recompose/compose';

import { encodeStorage, encodeStorageLatin, removeStorage } from 'functions/storageBase64';
import { useHistory } from 'react-router-dom';
import CardTitleEvent from 'newComponents/CardTitleEvent';
import { hideLoader } from 'store/actions/commons';
import { useStore } from 'store';
import CardProduct from 'newComponents/cardProduct/showGifts';
import GiftsHeader from 'newComponents/GiftsHeader/GiftsHeaderNavigate';
import OnlyStore from 'newComponents/cardProduct/addOnlyStore';
import styles from './styles.module.sass';
import MyEventsModule from 'newComponents/MyEvents';
import MenuMultiButons from 'newComponents/MenuMultiButons';


const NewTableAdmin = ({ values, agentTableId, agentStaffId }) => {
    agentStaffId && removeStorage('CURRENT_GIFT_TABLE')
    
    const history = useHistory();

    const [giftTable, dispatch] = useStore((state) => state.giftTable.giftTable)
    const [ giftsProducts, setGiftsProducts ] = useState([])
    const [ giftsStoreProducts, setGiftsStoreProducts ] = useState([])
    const [ linea, setLinea ] = useState()
    const [ evento, setEvento ] = useState()
    const [ plan, setPlan ] = useState()
    const [ invitados, setInvitados ] = useState()
    const [ festejado, setFestejado ] = useState()
    const [ festejado2, setFestejado2 ] = useState(null)
    
    const [ responseTable, setResponseTable ] = useState(null)
    const [ total, setTotal ] = useState()
    const [ isEmpty, setIsEmpty ] = useState()

    // cambia botones de linea y tienda
    const handleInLine = (idLine) => {
        if(idLine === 1){ setLinea(1) }
        else if(idLine === 2){ setLinea(2) }
        else if(idLine === 3){ setLinea(3) }
        else if(idLine === 4){ setLinea(4) }
    }

    const handleAddProduct = () => {
        history.push('/agregar-regalos')
    }

    useEffect(()=>{
        const ruta =  Number(window.location.search.split('=')[1] || 1)
        if(ruta != 1 && ruta != 3 && ruta != 4 ){
            setLinea(1)
        }else{
            setLinea(ruta)
        }
    },[])

    useEffect(()=>{
        if(responseTable){
            const eve = responseTable?.type?.name
            const pla = responseTable?.plan?.name
            const inv = `${responseTable?.guest_range?.minimum} - ${responseTable?.guest_range?.maximum}`
            const fes = responseTable?.celebrate_labels?.length >= 1 ? responseTable?.celebrate_labels[0]?.label?.value : null
            const fes2 = responseTable?.celebrate_labels?.length > 1 ? responseTable?.celebrate_labels[1]?.label?.value : null
            setEvento(eve)
            setPlan(pla)
            setInvitados(inv)
            setFestejado(fes)
            setFestejado2(fes2)

            try{
                encodeStorage('GIFT_TABLE_DATA', responseTable)
            }catch(err){
                encodeStorageLatin('GIFT_TABLE_DATA', responseTable)
            }
            // setLinea(1)
            setTimeout(()=>{
                if(total === null && isEmpty === null){
                    setTotal([])
                    setIsEmpty(true)
                }
                dispatch(hideLoader());
            },2500)
        }
        if(giftTable?.gifts_only_store || responseTable?.gifts_only_store){
            const gifts_only_store = responseTable?.gifts_only_store
            const singleProduct =  gifts_only_store?.filter( (prod, index, self) => index === self?.findIndex((t) => t?.sku === prod?.sku))

            setGiftsStoreProducts(singleProduct)
        }
    },[ responseTable ])

    useEffect(()=>{
        if(total){
            const gifts = total
            setGiftsProducts(gifts)
            dispatch(hideLoader());
        }
        if(isEmpty){
            dispatch(hideLoader());
        }
    },[ total, isEmpty ])

    return(
        <>
            <GiftsHeader
                sendProducts
                setResponseTable={setResponseTable}
                setTotal={setTotal}
                setIsEmpty={setIsEmpty}
            />
            <div className={styles?.externalContainer}>
                <CardTitleEvent
                    responseTable={responseTable}
                />
                <div className={`containerPortal ${styles?.container} ${styles?.myTable}`}>
                    <div className={`${styles?.contTitles}`}>

                        <MenuMultiButons 
                            handleInLine={handleInLine}
                            linea={linea}
                        />

                    </div>

                    <div>
                        {linea === 1
                            ?
                                giftsProducts?.length >= 1
                                    ?
                                        <div className={styles?.contCardsProducts}>
                                            {giftsProducts?.map(product => (
                                                <CardProduct
                                                    key={product?.id}
                                                    item={product}
                                                /> 
                                            )) }
                                            {giftsStoreProducts?.length >= 1
                                                ?
                                                    giftsStoreProducts?.map(producto => (
                                                        <OnlyStore
                                                            producto={producto}
                                                        />
                                                    )) 
                                                : null
                                            }
                                        </div>
                                    : 
                                        isEmpty && giftsProducts?.length === 0
                                            ?
                                                <div className={styles?.emptyProducts}>
                                                    <h2>Escoge tus regalos</h2>
                                                    <div className={styles?.imgStore} />
                                                    <p>Es momento de llenar la mesa de tus regalos favoritos.</p>
                                                    <p onClick={handleAddProduct} className={styles?.links} aria-hidden>Escoger regalos</p>
                                                </div>
                                            : null
                            : null
                        }
                    </div>

                    {linea === 3
                        ?
                            <div className={styles?.contEventoData}>
                                <p>Los campos base del evento no podrán ser editados</p>
                                <dl>
                                    <dt>Tipo de Evento</dt><dd>{evento}</dd>
                                    <dt>Tipo de Plan</dt><dd>{plan}</dd>
                                    <dt>Número de invitados</dt><dd>{invitados}</dd>
                                    <dt>Festejado(a)</dt><dd>{festejado}</dd>
                                    {festejado2
                                        ? 
                                            <>
                                                <dt>Festejado(a)</dt><dd>{festejado2}</dd>
                                            </>
                                        : null
                                    }
                                </dl>
                            </div>
                        : null
                    }

                    {linea === 4
                        ?
                            giftTable?.applyBonification
                                ?
                                    <div className={styles?.contEventoData}>
                                        <span className={styles?.textBienvenida}><b>Regalo de bienvenida </b><font color="red"><i className="fa fa-gift fa-1x "/></font></span>
                                        {
                                            giftTable?.coupon
                                                ?
                                                    giftTable?.coupon_redimed
                                                        ? <p className={styles?.coupon}>Este cupón ya ha sido redimido</p>
                                                        : <p className={styles?.coupon}>{giftTable?.coupon}</p>
                                                : 
                                                    <p className={styles?.textGift}>Para tener tu cupón de regalo de Bienvenida, debes tener al menos $500 en regalos</p>
                                        }
                                    </div>
                                : null
                        : null
                    }
                </div>
            </div>
        </>
    )
}



export default compose(
    withLayout,
    withAgentPage({ fetchTableInfo: true })
)(NewTableAdmin);